import { styled, Table } from "@tm/components"

export const StyledTable = styled(Table)({
    ".Table-columnHeader": {
        textTransform: "uppercase",
        fontSize: 12,
    },
    ".Table-cell": {
        fontSize: 14,
    },
})
